import {inject, Injectable} from '@angular/core';
import {from, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Validation, TopLevelDomain, NameServer, TrustAnchor} from '@iana-rzms/bff-sdk';
import {ErrorVO} from '../generate/ErrorVO';
// TODO(RZ-2562): Replace legacy VO types (OrganizationVO, ContactVO) with SDK equivalents (Organization, ContactInformation)
import {OrganizationVO} from '../generate/OrganizationVO';
import {ContactVO} from '../generate/ContactVO';
import {BffClientService} from './bff-client.service';
import {UtilService} from '../util/util.service';

@Injectable()
export class ValidatorService {

  private bffClientService = inject(BffClientService);
  private utilService = inject(UtilService);

  validateSOContact(organization: OrganizationVO): Observable<ErrorVO> {
    return from(Validation.getOrganizationValidationErrors(
      this.bffClientService.withDefaults({
        responseStyle: 'data',
        body: organization as any
      })
    )).pipe(map(response => this.utilService.normalizeErrors(response as any) as any));
  }

  validateContactInfo(contact: ContactVO): Observable<ErrorVO> {
    return from(Validation.getContactInfoValidationErrors(
      this.bffClientService.withDefaults({
        responseStyle: 'data',
        body: contact as any
      })
    )).pipe(map(response => this.utilService.normalizeErrors(response as any) as any));
  }

  validateNameServers(nameServers: Array<NameServer>, tldName?: string): Observable<ErrorVO> {
    return from(Validation.getNameServerValidationErrors(
      this.bffClientService.withDefaults({
        responseStyle: 'data',
        body: nameServers as any,
        query: tldName ? { tldName } : undefined
      })
    )).pipe(map(response => this.utilService.normalizeErrors(response as any) as any));
  }

  validateTrustAnchors(trustAnchors: Array<TrustAnchor>): Observable<ErrorVO> {
    return from(Validation.getTrustAnchorValidationErrors(
      this.bffClientService.withDefaults({
        responseStyle: 'data',
        body: trustAnchors as any
      })
    )).pipe(map(response => this.utilService.normalizeErrors(response as any) as any));
  }

  validateAdditionalInfo(originalTld: TopLevelDomain, tld: TopLevelDomain): Observable<ErrorVO> {
    return from(Validation.getAdditionalInfoValidationErrors(
      this.bffClientService.withDefaults({
        responseStyle: 'data',
        body: {
          originalTld: this.utilService.removeNullProperties(originalTld),
          proposedTld: tld
        } as any
      })
    )).pipe(map(response => this.utilService.normalizeErrors(response as any) as any));
  }
}
